import React from 'react';
import { useSelector } from 'react-redux';

import UnSuccess from 'Components/WalletPayment/StatusTransaction/UnSuccess';
import Success from 'Components/WalletPayment/StatusTransaction/Success';
import { walletPaymentSelectors } from 'Ducks';

const StatusTransaction = () => {
	const status = useSelector(walletPaymentSelectors.selectBarcodeStatus);
	const error = useSelector(walletPaymentSelectors.selectBarcodeError);
	const amount = useSelector(walletPaymentSelectors.selectTotalAmount);

	return (
		<>{status ? <Success amount={amount} /> : <UnSuccess error={error} />}</>
	);
};

export default StatusTransaction;
